type AppEventId = 'booking_button_clicked' | 'booking_confirmation';

type EventName = 'booking_start' | 'booking_confirmation';

type EventCategory = 'booking_start' | 'booking_confirmation';

type EventAction = 'click';

type EventLabel = 'some_label';

export type TrackingCustomEvent = Required<BasicCustomEvent> & {
  event: 'app_event';
};

type BasicCustomEvent = Required<{
  appEventId: AppEventId;
}> &
  Partial<{
    gaEventName: EventName | null;
    gaCategory: EventCategory | null;
    gaAction: EventAction | null;
    gaNonInteraction: boolean | null;
    gaLabel: EventLabel | string | null;
    gaValue: string | number | null;
    bookingId?: string | null;
    hotelId?: string | null;
    transactionValue?: number | null;
  }>;

const addToGtmDataLayer = (data: TrackingCustomEvent) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
};

const dispatchGtmAppEvent = (event: BasicCustomEvent) => {
  // Data Layer for an event is cumulative, so should always start from a clean, defaulted event and then update with new values
  addToGtmDataLayer({
    event: 'app_event',
    gaNonInteraction: false,
    gaEventName: null,
    gaCategory: null,
    gaAction: null,
    gaLabel: null,
    gaValue: null,
    bookingId: null,
    hotelId: null,
    transactionValue: null,
    ...event,
  });
};

export default dispatchGtmAppEvent;
